import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=78e83986&scoped=true&"
import script from "./video-list.vue?vue&type=script&lang=js&"
export * from "./video-list.vue?vue&type=script&lang=js&"
import style0 from "./video-list.vue?vue&type=style&index=0&id=78e83986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e83986",
  null
  
)

export default component.exports